import { type JSX, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { useMutation } from "urql";
import AiLoader from "../../shared/components/ai/AiLoader";
import RenderMark from "../../shared/components/RenderMark";
import t from "../../shared/translations";
import ShowError from "../components/ShowError";
import { graphql } from "../gql";
import { ButtonAnchor } from "../task/stylings";

const Wrapper = styled.section`
    display: grid;
    gap: 1rem;
    align-content: start;
`;

const OutputBox = styled.div`
    border: 1px solid var(--grey-3-color);
    padding: 1rem;
    max-width: 1000px;
`;

const createMutation = graphql(`
    mutation AppAiPathTakeawayCreate($pathId: ID!) {
        aiPathTakeawayCreate(pathId: $pathId) {
            error
            aiPathTakeaway {
                id
                output
                pdfSrc
            }
        }
    }
`);

function MyLearningPathSummary(): JSX.Element {
    const { pathId = "" } = useParams();
    const [{ data, fetching, error }, execute] = useMutation(createMutation);

    useEffect(() => {
        if (pathId) {
            execute({ pathId }).catch(() => {});
        }
    }, [pathId, execute]);

    if (fetching) {
        return <AiLoader />;
    }

    if (error) {
        return <ShowError />;
    }

    const result = data?.aiPathTakeawayCreate;
    if (!result) {
        return <ShowError />;
    }

    if (result.error) {
        return <ShowError error={result.error} />;
    }

    const take = result.aiPathTakeaway;
    if (!take) {
        return <ShowError />;
    }

    return (
        <Wrapper>
            <OutputBox>
                <RenderMark content={take.output} />
            </OutputBox>
            <div>
                <ButtonAnchor href={take.pdfSrc} target="_blank" download style={{ marginBottom: 0 }}>
                    {t("player.learning-path-summary.button-download")}
                </ButtonAnchor>
            </div>
            <div>
                <Link to="../.." relative="path">
                    {t("player.learning-path-summary.link-back")}
                </Link>
            </div>
        </Wrapper>
    );
}

export default MyLearningPathSummary;
